import { render, staticRenderFns } from "./BnkCatalogue.vue?vue&type=template&id=2a18e08b&"
import script from "./BnkCatalogue.vue?vue&type=script&lang=js&"
export * from "./BnkCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./BnkCatalogue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports